import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { getOrderDataById, orderEasyUpdate } from "../../../../services/clinicPortalServices/orderEditService";
import { Autocomplete, TextField } from "@mui/material";
import { ModalStyled } from "../../../../theme/customizedStyleComponents";
import { individualTestStatuses, orderStatuses } from "../../../../services/common/optionsData";

export default class OrderStatusPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            status: ""
        };
    }

    componentDidMount() {}

    componentDidUpdate(prevProps) {
        if (this.props.show && this.props.show !== prevProps.show) {
            getOrderDataById(this.props.data._id).then((res) => {
                this.setState({
                    orderDetails: res.data,
                    status: res.data.status
                });
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        let params = {
            _id: this.state.orderDetails._id,
            status: this.state.status
        };
        orderEasyUpdate(params).then((response) => {
            this.props.context.componentParent.loadGridData();
            this.props.handleClose();
        });
    };

    render() {
        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Order Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.orderDetails && (
                        <div className="row">
                            <div className="col-12">Current Status: {this.state.orderDetails.status}</div>
                            <div className="col-12 mt-4">
                                <Autocomplete
                                    options={
                                        this.state.orderDetails.order_type === "root"
                                            ? orderStatuses
                                            : individualTestStatuses
                                    }
                                    value={this.state.status}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            status: newValue
                                        });
                                    }}
                                    getOptionLabel={(option) => (option ? option : "")}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Status *" />
                                    )}
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleSave}
                        disabled={this.state.status !== this.props.data.status ? false : true}
                    >
                        Save
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}
